"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _CoreInput = require("../../utilities/CoreInput");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Checkbox = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
    disabled,
    label,
    invalid,
    id,
    name,
    readonly,
    checked,
    onChange,
    className,
    indeterminate,
    value
  } = props;
  const checkboxClassNames = (0, _classnames.default)({
    'is-indeterminate': indeterminate
  });
  const [isChecked, setIsChecked] = (0, _react.useState)();
  (0, _react.useEffect)(() => {
    setIsChecked(checked);
  }, [checked]);
  return /*#__PURE__*/_react.default.createElement("label", {
    className: (0, _classnames.default)('checkbox', className) || undefined,
    disabled: disabled,
    htmlFor: id
  }, /*#__PURE__*/_react.default.createElement("input", {
    ref: ref,
    id: id,
    name: name,
    type: "checkbox",
    checked: isChecked,
    readOnly: readonly,
    disabled: disabled,
    "aria-invalid": invalid,
    className: checkboxClassNames,
    value: value,
    onChange: () => {
      const toggle = !isChecked;
      setIsChecked(toggle);
      onChange(toggle);
    }
  }), /*#__PURE__*/_react.default.createElement("span", null, label));
});
Checkbox.displayName = 'Checkbox';
Checkbox.propTypes = {
  checked: _propTypes.default.bool,
  label: _propTypes.default.string,
  value: _propTypes.default.string,
  className: _propTypes.default.string,
  indeterminate: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  invalid: _propTypes.default.bool,
  readonly: _propTypes.default.bool,
  id: _propTypes.default.string,
  name: _propTypes.default.string,
  onChange: _propTypes.default.func
};
var _default = exports.default = (0, _CoreInput.withControl)(Checkbox);
//# sourceMappingURL=Checkbox.js.map